import ResetPasswordSuccess from "../../sections/reset-password/reset-password-success";

const PasswordSuccessPage = () => {
  return <ResetPasswordSuccess />;
};

export default PasswordSuccessPage;
